import AsyncAlpine from 'async-alpine';
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";

/* 1st party magic */
import './_magic/smoothscroll.js';

/* 1st party components */
import cookieConsent from "./cookieConsent.js";
import html5Video from "./html5Video/index.js";
import moodboard from "./moodboard.js";
import newsletter from "./newsletter.js";
import autosuggest from "./autosuggest.js";
import googleMap from "./google-map.js";
import variantSelector from "./shop/variantSelector";

/* plugins */
Alpine.plugin(AsyncAlpine);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(collapse);

/* data components */
Alpine.data("cookieConsent", cookieConsent);
Alpine.data("html5Video", html5Video);
Alpine.data("moodboard", moodboard);
Alpine.data("newsletter", newsletter);
Alpine.data("autosuggest", autosuggest);
Alpine.data("googleMap", googleMap);
Alpine.data("variantSelector", variantSelector);

/* async data components */
Alpine.asyncData('slideshow', () => import('./slideshow.js'));

Alpine.store('gmaps', {
  loaded: false,

  load() {
    if(!window.GOOGLE_MAPS_SCRIPTS) return;

    if (this.loaded) return Promise.resolve();

    const promises = window.GOOGLE_MAPS_SCRIPTS.map(url => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = () => resolve(url);
        script.onerror = () => reject(new Error(`Failed to load ${url}`));
        document.body.appendChild(script);
      });
    });

    return Promise.all(promises).then(() => {
      this.loaded = true;
    });
  }
});

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
